// extracted by mini-css-extract-plugin
export var headerCell = "_3x-1";
export var loadingSpinnerContainer = "_3x-4";
export var rowWrapper = "_3x-3";
export var standaloneTable = "_3x-5";
export var table = "_3x-0";
export var white = "_3x-2";